// sci_version is NULL while a version upgrade runs; fall back to the version
// of the kit's last pipeline run so version-dependent UI keeps working.
export const getKitSciVersion = (kit) => kit?.sci_version || kit?.pipeline_sci_version || '';
//# sourceMappingURL=getKitSciVersion.js.map